document.addEventListener("DOMContentLoaded",()=>{const popup=document.querySelector("[data-signup-popup]");if(popup&&!localStorage.getItem("awenzo_welcome_seen"))setTimeout(()=>popup.style.display="flex",1600);document.querySelectorAll("[data-popup-close]").forEach(b=>b.addEventListener("click",()=>{popup.style.display="none";localStorage.setItem("awenzo_welcome_seen","1")}));document.querySelector("[data-signup-form]")?.addEventListener("submit",e=>{e.preventDefault();localStorage.setItem("awenzo_welcome_seen","1");const email=e.target.querySelector("input").value.trim();location.href="{{ routes.account_login_url }}?email="+encodeURIComponent(email)});document.querySelectorAll("[data-remove-line-item]").forEach(b=>b.addEventListener("click",async()=>{b.disabled=true;await fetch("/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({id:b.dataset.lineKey,quantity:0})});location.reload()}));document.querySelectorAll("[data-cart-minus],[data-cart-plus]").forEach(b=>b.addEventListener("click",async()=>{const input=b.closest(".qty")?.querySelector("[data-cart-qty]");if(!input)return;let q=parseInt(input.value||"1",10);if(!Number.isFinite(q))q=1;q=b.hasAttribute("data-cart-minus")?Math.max(0,q-1):q+1;b.disabled=true;try{await fetch("/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({id:b.dataset.lineKey,quantity:q})});location.reload()}catch(e){b.disabled=false}}));});
/* AWENZZO V27 wishlist */
(function(){
  const KEY='awenzo_wishlist_v1';
  const get=()=>{try{return JSON.parse(localStorage.getItem(KEY)||'[]')}catch(e){return[]}};
  const save=(items)=>localStorage.setItem(KEY,JSON.stringify(items));
  const esc=(s)=>String(s||'').replace(/[&<>"']/g,m=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m]));
  const drawer=document.querySelector('[data-wishlist-drawer]');
  const backdrop=document.querySelector('[data-wishlist-backdrop]');
  const list=document.querySelector('[data-wishlist-items]');
  const empty=document.querySelector('[data-wishlist-empty]');
  function open(){if(!drawer)return;drawer.classList.add('is-open');drawer.setAttribute('aria-hidden','false');if(backdrop)backdrop.hidden=false;render();}
  function close(){if(!drawer)return;drawer.classList.remove('is-open');drawer.setAttribute('aria-hidden','true');if(backdrop)backdrop.hidden=true;}
  function render(){
    const items=get();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(btn=>{
      const card=btn.closest('[data-wishlist-item]'); if(!card)return;
      const saved=items.some(x=>x.url===card.dataset.wishlistUrl);
      btn.classList.toggle('is-saved',saved);btn.textContent=saved?'♥':'♡';btn.setAttribute('aria-label',saved?'Remove from wishlist':'Add to wishlist');
    });
    if(!list||!empty)return;
    if(!items.length){list.innerHTML='';empty.hidden=false;return;}
    empty.hidden=true;
    list.innerHTML=items.map((x,i)=>`<div class="wishlist-item"><img src="${esc(x.image)}" alt="${esc(x.title)}"><div><a class="wishlist-item-title" href="${esc(x.url)}">${esc(x.title).replace(/AWENZZO/g,'<span class="awenzo-brand-text">AWENZZO</span>')}</a><div class="wishlist-item-price">${esc(x.price)}</div></div><div class="wishlist-item-actions"><a class="wishlist-view" href="${esc(x.url)}">View</a><button class="wishlist-remove" type="button" data-wishlist-remove="${i}">Remove</button></div></div>`).join('');
    list.querySelectorAll('[data-wishlist-remove]').forEach(b=>b.addEventListener('click',()=>{const a=get();a.splice(Number(b.dataset.wishlistRemove),1);save(a);render();}));
  }
  document.addEventListener('click',e=>{
    const openBtn=e.target.closest('[data-wishlist-open]');
    if(openBtn){e.preventDefault();open();return;}
    const toggle=e.target.closest('[data-wishlist-toggle]');
    if(toggle){e.preventDefault();const card=toggle.closest('[data-wishlist-item]');if(!card)return;const a=get(),url=card.dataset.wishlistUrl;const idx=a.findIndex(x=>x.url===url);if(idx>=0)a.splice(idx,1);else a.push({url,title:card.dataset.wishlistTitle,price:card.dataset.wishlistPrice,image:card.dataset.wishlistImage});save(a);render();return;}
    if(e.target.closest('[data-wishlist-close]')||e.target===backdrop)close();
  });
  document.addEventListener('keydown',e=>{if(e.key==='Escape')close();});
  render();
})();


// AWENZZO V36 account notification preference
document.addEventListener("DOMContentLoaded",()=>{
  const key="awenzo_notifications_enabled";
  document.querySelectorAll("[data-awenzo-notifications]").forEach(input=>{
    const saved=localStorage.getItem(key);
    if(saved!==null) input.checked=saved!=="0";
    input.addEventListener("change",()=>localStorage.setItem(key,input.checked?"1":"0"));
  });
});
// AWENZZO V38 — show floating mobile navigation while scrolling up; hide while scrolling down.
document.addEventListener('DOMContentLoaded',()=>{
  const nav=document.querySelector('[data-mobile-bottom-nav]');
  if(!nav || !window.matchMedia('(max-width: 900px)').matches) return;
  let lastY=Math.max(0,window.scrollY);
  let ticking=false;
  const update=()=>{
    const y=Math.max(0,window.scrollY);
    const delta=y-lastY;
    const atTop=y<=40;
    if(atTop || delta>0){
      nav.classList.remove('is-visible');
    }else if(delta<0 && y>40){
      nav.classList.add('is-visible');
    }
    lastY=y;
    ticking=false;
  };
  window.addEventListener('scroll',()=>{
    if(!ticking){
      window.requestAnimationFrame(update);
      ticking=true;
    }
  },{passive:true});
  update();
});

